import React from 'react';
import ProfileIntegrations from './ProfileIntegrations';

const ProfileLeft = ({loading, userData }) => {
  return (
    <div className="profile-left">
      <ProfileIntegrations
          loading={loading}
          userData={userData}
      />
    </div>
  );
};

export default ProfileLeft;
